import { useQuery } from '@tanstack/react-query';
import useAxiosProtect from './useAxiosProtect';
import useAuth from './useAuth';

const getJSON = (axios, url, name) => {
    // console.log(`${name} running`)
    return axios.get(url).then(response => response.data)
}

const isInternalUser = role => role === process.env.REACT_APP_ES_ADMIN || role === process.env.REACT_APP_ES_USER;

export const useOrgs = () => {
    const {auth} = useAuth();
    const axiosProtect = useAxiosProtect();
    const enabled = isInternalUser(auth?.role);

    return useQuery({
        queryKey: ['orgs'],
        queryFn: () => getJSON(axiosProtect, '/auth/query/list-all-orgs', 'orgs'),
        enabled,
        select: data => (data.orgs ?? []).map(o => ({ id: o._id, name: o.name, siteIDs: o.siteIDs }))
    });
}

export const useSites = ({ orgID, siteID } = {}) => {
    const {auth} = useAuth();
    const axiosProtect = useAxiosProtect();

    const paramKey = orgID ? 'orgID' : siteID ? 'siteID' : null;
    const paramVal = orgID ?? siteID;
    const enabled = isInternalUser(auth?.role) && !!paramVal;

    let url = paramKey ? `/auth/query/list-org-sites?${paramKey}=${encodeURIComponent(String(paramVal))}` : null;

    return useQuery({
        queryKey: ['sites', 'org', String(orgID ?? '')],
        // queryKey,
        queryFn: () => getJSON(axiosProtect, url, 'sites'),
        enabled,
        keepPreviousData: true, 
        select: data => (data.sites ?? []).map(s => ({ id: String(s.id), name: s.name, org_id: s.org_id }))
    });
}